import type { RoomDef } from '../../sim/room';

/**
 * The prototype's test room on the jungle world: one room, three lanes. Lane 0 has a pit and a
 * wall too tall to jump; lane 1 goes round them but has a 12-tile gap; lane 2 hides Starlight.
 * `.` empty · `#` solid · `=` one-way · `P` start · `*` Starlight cell · `c` crawler.
 */
export const JUNGLE_TEST: RoomDef = {
  id: 'jungle-test',
  name: 'Jungle world: test room',
  lanes: [
    // Lane 0 (near)
    [
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '........................................................*.......................................',
      '........................................................##......................................',
      '...................**...................................##...................................###',
      '..................====..................................##...................................###',
      '........................................................##...................................###',
      '........................................................##.................*.................###',
      '............=====.......................................##................====...............###',
      '........................................................##...................................###',
      '........................................................##...................................###',
      '...P....................c...............................##......c.................c..........###',
      '###############################....#############################################################',
      '###############################....#############################################################',
      '###############################....#############################################################',
    ],
    // Lane 1 (middle)
    [
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '.....................................................**.........................................',
      '....................................................====........................................',
      '.............................................................................................###',
      '................................................*............................................###',
      '..............................................=====..........................................###',
      '.............................................................................................###',
      '..........................................*..................................................###',
      '........................................=====................................................###',
      '..........................####...............................................................###',
      '..........................####......c.......................c................................###',
      '####################################################################............################',
      '####################################################################............################',
      '####################################################################............################',
    ],
    // Lane 2 (far)
    [
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '................................................................................................',
      '.............................................................................................###',
      '.............................................................................................###',
      '.............................................*.*.*...........................................###',
      '............................................=======..........................................###',
      '............................................................###..............................###',
      '............................................................###..............................###',
      '............................................................###..............................###',
      '....................c...............................c.......###.......................c......###',
      '################################################################################################',
      '################################################################################################',
      '################################################################################################',
    ],
  ],
};
